import { render, staticRenderFns } from "./PurchaseProtocol.vue?vue&type=template&id=1540807a&scoped=true"
import script from "./PurchaseProtocol.vue?vue&type=script&lang=js"
export * from "./PurchaseProtocol.vue?vue&type=script&lang=js"
import style0 from "./PurchaseProtocol.vue?vue&type=style&index=0&id=1540807a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1540807a",
  null
  
)

export default component.exports